import { get, put, post, delet } from '@core/request';
import { post as clientPost } from '@core/http_client';
import config from '@config';

// 获取报名物料配置
export const getSuppliesPageApi = params => {
    return get('/conference/boss/supplies/list', params);
};

// 获取报名物料配置
export const updateSuppliesPageApi = data => {
    return put('/conference/boss/supplies/update', data);
};

// 获取身份权益配置列表
export const getConferenceIdentitySuppliesApi = params => {
    return get('/conference/boss/activitybenefits/list', params);
};

// 保存身份权益配置
export const saveConferenceIdentitySuppliesApi = data => {
    return post('/conference/boss/activitybenefits/save', data);
};

// 保存身份权益配置
export const updateConferenceIdentitySuppliesApi = data => {
    return put('/conference/boss/activitybenefits/update', data);
};

// 删除身份权益配置
export const deleteConferenceIdentitySuppliesApi = params => {
    return get('/conference/boss/activitybenefits/delete', params);
};

// 报名列表
export const registrationsListApi = params => {
    return get('/conference/activityregistragtionusers/conference/page', params);
};

// 报名列表
export const registrationsGetOneApi = params => {
    return get('/conference/boss/registrations/getOne', params);
};

// 报名列表 - 删除
export const registrationsDeleteApi = params => {
    return get('/conference/activityregistragtionusers/delete', params);
};

// 报名列表 - 设置联系人
export const registrationsSetContactApi = params => {
    return put('/conference/boss/registrations/set-contract', params);
};

// 报名列表 - 导入数据模板
export const importDataCheckApi = params => {
    return post('/conference/activityregistragtionusers/import-check', params, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

// 报名列表 - 开始导入数据
export const confirmImportDataApi = params => {
    return post('/conference/activityregistragtionusers/import', params);
};

// 报名列表 - 添加报名
export const addRegistrationsApi = params => {
    return post('/conference/activityregistragtionusers/conference/save', params);
};

// 单位机构列表
export const caseOrganizationApi = data => {
    return get(`/dataengine/api/organisationinfo/search`, data);
};

// 单位机构新增
export const caseAddOrganizationApi = data => {
    return post(`/dataengine/admin/organisationinfo/save`, data);
};

// 认证身份接口
export const authdictionaryApi = data => {
    return get(`/dataengine/api/authdictionary/json/ex`, data);
};

// 认证身份接口
export const sendMpMessageApi = data => {
    return get(`/conference/boss/registrations/sendMpMessage`, data);
};

// 报名身份列表
export const getActivityIdentitiesApi = data => {
    return get(`/conference/boss/activityidentities/list`, data);
};

// 新增身份
export const saveActivityidentitiesApi = data => {
    return post(`/conference/boss/activityidentities/save`, data);
};

// 编辑身份
export const updateActivityidentitiesApi = data => {
    return put(`/conference/boss/activityidentities/update`, data);
};

// 删除身份
export const deleteActivityidentitiesApi = data => {
    return get(`/conference/boss/activityidentities/delete`, data);
};

// 报名模板列表
export const activityregistrationsApi = data => {
    return get(`/conference/boss/activityregistrations/list`, data);
};

// 删除报名模板
export const deleteActivityregistrationsApi = data => {
    return get(`/conference/boss/activityregistrations/delete`, data);
};

// 新增保存报名模板
export const saveActivityregistrationsApi = data => {
    return post(`/conference/boss/activityregistrations/saveRegistration`, data);
};

// 编辑保存报名模板
export const updateActivityregistrationsApi = data => {
    return put(`/conference/boss/activityregistrations/update`, data);
};

// 获取报名模板详情
export const activityregistrationsDetailApi = data => {
    return get(`/conference/boss/activityregistrations/getById`, data);
};

// 保存题目
export const saveQuestionsApi = data => {
    return post(`/conference/boss/activityregistrationquestions/saveByConference`, data);
};

// 修改题目
export const updateQuestionsApi = data => {
    return put(`/conference/boss/activityregistrationquestions/updateByConference`, data);
};

// 题目列表
export const getQuestionsListApi = data => {
    return get(`/conference/boss/activityregistrationquestions/list`, data);
};

// 删除题目
export const deleteQuestionsListApi = data => {
    return get(`/conference/boss/activityregistrationquestions/delete`, data);
};

// 报名渠道列表
export const getChannelListApi = data => {
    return get(`/channel/channel/page`, data);
};

// 签到题目列表
export const getQuestionsApi = data => {
    return get(`/conference/boss/activityregistrationquestions/conference/questions`, data);
};

// 根据id查询签到详情
export const getRegistragtionDetailApi = data => {
    return get(`/conference/activityregistragtionusers/getOne`, data);
};

// 获取小程序码data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA
export const getwxacodeApi = data => {
    return clientPost(`${config.API_PREFIX}/dataengine/api/mp/getwxacode`, data, { responseType: 'blob' });
};

// 获取小程序码文件流
export const getDowloadWxacodeApi = data => {
    return get(`/dataengine/api/mp/wxacode/dowload`, data, { responseType: 'blob' });
};
